const AdvancedFilterListComponent = {
    templateUrl: '/ui/advancedFilter/component/advancedFilterList/advancedFilterList.tpl.html',
    controller: 'advancedFilterListController',
    bindings: {
        filterModel: '<',
        showAllTemplates: '<',
        submission: '<',
        advancedFilterType: '<',
        allowClearFilter: '<',
        translationsKey: '<?',
        disableAutoFocus: '<?',
        oneClearFilter: '<',
        clearFilterIsLink: '<'
    }
};

angular.module('umCore')
    .component('uiAdvancedFilterList', AdvancedFilterListComponent);
